import './forbidden.css';
import warning from './401.png';

export default function Forbidden() {
    return (
        <div className="wms-forbidden-container">
            <img className="wms-forbidden-logo" src={warning} alt="WMS Warning Logo" />
            <div className="wms-forbidden-msg">You are not authorized to view this page</div>
        </div>);
}